import {
  GET_ENHANCED_SEARCH_TREE_VIEW_DATA,
  GET_ENHANCED_SEARCH_TREE_VIEW_DATA_FAILURE,
  GET_ENHANCED_SEARCH_TREE_VIEW_DATA_SUCCESS,
  GET_SEARCH_TREE_VIEW_DATA,
  GET_SEARCH_TREE_VIEW_DATA_FAILURE,
  GET_SEARCH_TREE_VIEW_DATA_SUCCESS,
  RESET_SEARCH_TREE_VIEW_DATA,
} from '../actions/SearchTreeViewDataActions';

const initialState = {};

function searchTreeViewDataReducer(state = initialState, action) {
  switch (action.type) {
    case GET_SEARCH_TREE_VIEW_DATA:
      return {
        ...state,
        [action.payload.entityName]: {
          loading: true,
        },
      };
    case GET_SEARCH_TREE_VIEW_DATA_SUCCESS:
      return {
        ...state,
        [action.payload.entityName]: {
          loading: false,
          searchTreeViewData: action.payload.searchTreeViewData,
        },
      };
    case GET_SEARCH_TREE_VIEW_DATA_FAILURE:
      return {
        ...state,
        [action.payload.entityName]: {
          loading: false,
          error: action.payload.error,
        },
      };
    case GET_ENHANCED_SEARCH_TREE_VIEW_DATA:
      return {
        ...state,
        [action.payload.entityName]: {
          loading: true,
        },
      };
    case GET_ENHANCED_SEARCH_TREE_VIEW_DATA_SUCCESS:
      return {
        ...state,
        [action.payload.entityName]: {
          loading: false,
          treeViewData: action.payload.treeViewData,
          advancedSearchCriteria: action.payload.advancedSearchCriteria,
        },
      };
    case RESET_SEARCH_TREE_VIEW_DATA: {
      return {};
    }
    case GET_ENHANCED_SEARCH_TREE_VIEW_DATA_FAILURE:
    default:
      return state;
  }
}

export default searchTreeViewDataReducer;
